import { Backbutton } from './../models/rootState.model';
import { Action_Header_BackButtonSet } from './../store/actions/header.actions';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { Injectable } from '@angular/core';
import { take, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<any>
  ) { }

  goAndReturn(commands: any[], extras?: NavigationExtras) {
    let qp: any = {};
    if (extras && extras.queryParams) {
      qp = extras.queryParams;
    }
    qp.locationBack = this.router.url;
    if (extras) {
      extras.queryParams = qp;
    } else {
      extras = {
        queryParams: qp
      };
    }
    return this.router.navigate(commands, extras);
  }

  go(commands: any[], extras?: NavigationExtras) {
    return this.router.navigate(commands, extras);
  }

  back() {
    this.route.queryParams.pipe(take(1))
      .subscribe(qp => {
        let commands = ['home'];
        if (qp.locationBack) {
          commands = (qp.locationBack as string).split('/');
        }
        this.router.navigate(commands);
      });
  }

  error() {

  }

  hasReturn() {
    const locationBack = 'locationBack';
    return this.route.queryParams.pipe(
      take(1),
      map(qp => !!(qp[locationBack]))
    );

  }

  displayBackButton() {
    this.hasReturn()
      .subscribe((hasReturn) => {
        let action: Backbutton = true;
        if (hasReturn) {
          action = () => {
            this.back();
          };
        }

        // to prevent changeDetection warning
        setTimeout(() => {

          this.store.dispatch(new Action_Header_BackButtonSet(action));

        }, 1);
      });
  }

}
